/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAidSchemeModel } from '../../models/medical-aid-scheme-model';

export interface MedicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet$Params {
  medicalAidId: string;
  medicalAidSchemeId: string;
}

export function medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet(http: HttpClient, rootUrl: string, params: MedicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidSchemeModel>> {
  const rb = new RequestBuilder(rootUrl, medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet.PATH, 'get');
  if (params) {
    rb.path('medicalAidId', params.medicalAidId, {});
    rb.path('medicalAidSchemeId', params.medicalAidSchemeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<MedicalAidSchemeModel>;
    })
  );
}

medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet.PATH = '/MedicalAid/MedicalAidSchemeGet/{medicalAidId}/{medicalAidSchemeId}';
